import { render } from "./organisation_payment_account.html?vue&type=template&id=43a330fc&external"
import script from "./organisation_payment_account.js?vue&type=script&lang=js&external"
export * from "./organisation_payment_account.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__